var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('casa-form',{attrs:{"idBusiness":_vm.idBusiness,"idCasa":_vm.idCasa,"pag":_vm.pag,"idSubproducto":_vm.idSubproducto,"desdeSubproducto":_vm.desdeSubproducto}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2851df95","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Configuracion/Casas/Casa.vue
// module id = uBEu
// module chunks = 4